import {
  ApplicationRef,
  ComponentFactoryResolver,
  ComponentRef,
  EmbeddedViewRef,
  Injectable,
  Injector
} from '@angular/core';
import {Subscription} from 'rxjs';
import {AccessDeniedModalComponent} from '../_shared/components/access-denied-modal/access-denied-modal.component';

@Injectable({providedIn: 'root'})
export class AccessDeniedModalService {
  private isModalOpen = false;
  private componentRef: ComponentRef<AccessDeniedModalComponent> = null;
  private closeSubscription: Subscription = null;

  constructor(
    private componentFactoryResolver: ComponentFactoryResolver,
    private appRef: ApplicationRef,
    private injector: Injector
  ) {
  }

  showAccessDeniedModal(): void {
    if (this.isModalOpen) {
      return;
    }

    this.isModalOpen = true;
    const componentFactory = this.componentFactoryResolver.resolveComponentFactory(AccessDeniedModalComponent);
    this.componentRef = componentFactory.create(this.injector);
    this.closeSubscription = this.componentRef.instance.closed.subscribe(() => this.closeAccessDeniedModal());
    this.appRef.attachView(this.componentRef.hostView);

    const element = (this.componentRef.hostView as EmbeddedViewRef<any>).rootNodes[0] as HTMLElement;
    document.body.appendChild(element);
    this.componentRef.changeDetectorRef.detectChanges();
  }

  closeAccessDeniedModal(): void {
    if (!this.isModalOpen) {
      return;
    }

    if (this.componentRef) {
      if (this.closeSubscription) {
        this.closeSubscription.unsubscribe();
        this.closeSubscription = null;
      }
      this.appRef.detachView(this.componentRef.hostView);
      this.componentRef.destroy();
      this.componentRef = null;
    }
    this.isModalOpen = false;
  }
}
